import React from 'react';
import PropTypes from 'prop-types';
import QuestionBarChart from '../QuestionBarChart';
import { surveyStatsType, questionTypeValues } from '../../constants/types';
import styles from './dimensionQuestionsSummary.module.css';
import { getTranslation, withLang, langType } from '../../i18n';
import { getSurveySchemaPartQuestions } from '../../util';
import QuestionSummaryLegend from '../QuestionSummaryLegend';

const minValue = (dist) => Math.min(...Object.keys(dist).map(Number));

const maxValue = (dist) => Math.max(...Object.keys(dist).map(Number));

const getLikertQuestionSummary = (question, questionStats, lang) => (
  <div className={styles.questionContainer} key={`div-q${question.id}`}>
    <h3 className={styles.questionHeader}>{getTranslation(question.text, lang)}</h3>
    <QuestionBarChart
      question={question}
      stats={questionStats}
      key={`ls-${question.id}`}
    />
    <QuestionSummaryLegend
      groupValue={questionStats.average}
      standardDeviation={questionStats.standardDeviation}
      distribution={questionStats.distribution}
      minValue={minValue(questionStats.distribution)}
      maxValue={maxValue(questionStats.distribution)}
    />
  </div>
);

const getDimensionQuestions = (survey) => {
  if (survey) {
    return survey.surveySchemaParts
      .reduce((acc, part) => acc.concat(getSurveySchemaPartQuestions(part)), []);
  }
  return [];
};

const getSummaryForQuestion = (question, surveyStats, lang) => {
  const questionStats = surveyStats.statisticsByQuestionId[question.id];
  switch (question.type) {
    case questionTypeValues.LIKERT:
      return getLikertQuestionSummary(question, questionStats, lang);
    default:
      return null;
  }
};

const DimensionQuestionsSummary = ({ surveyStats, questionCodes, lang }) => [
  <p key="n-count">N = {surveyStats.responseCount}</p>,
  <div key="dim-container" className={styles.container}>
    {getDimensionQuestions(surveyStats.survey).map((question) => (
      questionCodes.includes(question.code)
        ? getSummaryForQuestion(question, surveyStats, lang)
        : null
    ))}
  </div>
];

const { arrayOf, string } = PropTypes;

DimensionQuestionsSummary.propTypes = {
  surveyStats: surveyStatsType.isRequired,
  questionCodes: arrayOf(string).isRequired,
  ...langType
};

export default withLang(DimensionQuestionsSummary);
